import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ReplaySubject, Subject} from 'rxjs';
import {Partner} from '../../../shared/interface/partner';
import {takeUntil} from 'rxjs/operators';
import {PartnerService} from '../../../shared/services/partner.service';
import {ListResponse} from '../../../shared/interface/response/list-response';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {Uuid} from "../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../shared/components/job-result-dialog/job-result-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../shared/services/auth.service";

@Component({
  selector: 'app-child-partners-list',
  templateUrl: './child-partners-list.component.html',
  styleUrls: ['./child-partners-list.component.scss']
})
export class ChildPartnersListComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() partner: Subject<Partner>;
  @Input() overcommission  = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  childPartners: MatTableDataSource<Partner> = new MatTableDataSource<Partner>([]);
  displayedColumns: string[] = ['name', 'status', 'email', 'phone', 'assetsRegional', 'nip', 'regon', 'headquartersAddress'];
  userPermissions: ReplaySubject<UserPermissions>;
  initialFilters: any;
  partnerObject?: Partner;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private partnerService: PartnerService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.partner
      .pipe(takeUntil(this.destroyed$))
      .subscribe((partner: Partner) => {
        this.partnerObject = partner;
        if (!this.overcommission){
          this.partnerService.getChildPartners(partner.uuid)
            .subscribe((response: ListResponse<Partner>) => {
              this.childPartners.data = response.items;
            });
        } else {
          this.partnerService.getChildOvercommissionPartners(partner.uuid)
            .subscribe((response: ListResponse<Partner>) => {
              this.childPartners.data = response.items;
            });
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngAfterViewInit(): void {
    this.childPartners.paginator = this.paginator;
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};
    if (this.overcommission){
      filters.overcommissionPartner = this.partnerObject.uuid;
    } else {
      filters.parentPartner = this.partnerObject.uuid;
    }

    return filters;
  }

  downloadReport(): void {
      this.partnerService.downloadReportChildPartner(this.buildFilters())
        .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

}
